import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "7e0dfc6f-985e-439f-be7d-232bfeb8b25f",
    content: "Binaural impulse response include direction information of the sound source.",
    options: {},
  },
  {
    id: "22ae52f1-4bfd-4841-86d4-874939f06845",
    content: "Monaural impulse response include direction information of the sound source.",
    options: {},
  },
  {
    id: "07034c34-247c-4238-bf0c-7dcf66fd9b17",
    content: "If the source is very close to the head commonly used HRTF Databases are also valid.",
    options: {},
  },
];

export const task: Task = {
  id: "ca44a424-9804-4910-bc07-4e4e58e1bae8",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["7e0dfc6f-985e-439f-be7d-232bfeb8b25f"],
};
